
import { useParams } from "react-router-dom";
import { LayoutUsuarios } from "../../layouts";
import { CargandoMedio, TabsDinamicosTodo } from "../../components";
import { BuscadorXTermino } from "../../components/buscadores";
import { useListOpXUsuario } from "../../../hooks/cache";
import { TablaOpsPorCliente } from "../components";
import { Box } from "@mui/material";
import { useState } from "react";



const pagos = ['PENDIENTE', 'REALIZADO'];
export const VerOpsPorCliente = () => {

    
    const { id } = useParams();
    const [tabIndex, setTabIndex] = useState('PENDIENTE');
    const { data, isLoading, chagePage, page, termino, chageTermino } = useListOpXUsuario(id, tabIndex);


    const renderTabContent = () => {
        if (isLoading) {
            return <CargandoMedio titulo="Cargando información de ops..." />;
        }

        return  <>
                <BuscadorXTermino mT={3} termino={termino} chageTermino={chageTermino} texto="ops" playhol="op estado" />
                <TablaOpsPorCliente data={data || []} chagePage={chagePage} page={page} />
                </>;
    };


    return (

        <LayoutUsuarios titulo='Ordenes de Pedido'>
            <Box sx={{flex:1, display:'flex', flexDirection:'column', width:'100%'}}>
                <TabsDinamicosTodo
                    tabs={
                        pagos?.map((item) => ({
                            label: (item === 'REALIZADO') ? 'PAGAS' : item,
                            value: item,
                            component: renderTabContent()
                        }))
                    }
                    tabIndex={tabIndex}
                    setTabIndex={(nuevoValor) => {
                        setTabIndex(nuevoValor);
                        chagePage(1);
                    }}
                />
            </Box>
        </LayoutUsuarios>
    )
}
